import { render, staticRenderFns } from "./structures.vue?vue&type=template&id=a324d008&"
import script from "./structures.vue?vue&type=script&lang=js&"
export * from "./structures.vue?vue&type=script&lang=js&"
import style0 from "./structures.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports